import { create } from 'zustand';
import type { MindMapWebSocketProvider } from '@/collaboration/WebSocketProvider';
import type { CollaboratorAwareness } from '@/collaboration/awareness';

export interface CollaborationState {
  provider: MindMapWebSocketProvider | null;
  isConnected: boolean;
  collaborators: Map<number, CollaboratorAwareness>;

  setProvider: (p: MindMapWebSocketProvider | null) => void;
  setConnected: (c: boolean) => void;
  setCollaborators: (c: Map<number, CollaboratorAwareness>) => void;
}

export const useCollaborationStore = create<CollaborationState>((set) => ({
  provider: null,
  isConnected: false,
  collaborators: new Map(),

  setProvider: (provider) => set({ provider }),
  setConnected: (isConnected) => set({ isConnected }),
  setCollaborators: (collaborators) => set({ collaborators }),
}));
